"use client";

import { useContent } from "@/components/site/ContentProvider";

/** scroll-spine contact morph targets `.contact_cover > i` (scale / blur / load_bg). */
export function ContactCover() {
  const site = useContent();
  return (
    <div className="contact_cover full_page _tempHide" aria-hidden="true">
      <i className="cover load_bg" data-src={site.contact.cover} />
      {/* Extra dark veil — photo alone stays too bright under white form type. */}
      <div className="contact_cover_scrim" aria-hidden />
    </div>
  );
}
